<template>
    <v-row>
        <v-card-text>
            <p class="body-1">{{ $t('oampublication/label--spitalstellenmarkt-category-description') }}</p>
            <ValidationProvider
                v-slot="{ errors }"
                :name="$t('oampublication/label--spitalstellenmarkt-category-1')"
                rules="required"
            >
                <v-select
                    v-model="spitalstellenmarktCategoryID1"
                    :items="cboValues"
                    clearable
                    item-text="text"
                    item-value="id"
                    :label="$t('oampublication/label--spitalstellenmarkt-category-1')"
                    :error-messages="errors"
                    required
                ></v-select>
            </ValidationProvider>
            <v-select
                v-model="spitalstellenmarktCategoryID2"
                :items="cboValues"
                clearable
                item-text="text"
                item-value="id"
                :label="$t('oampublication/label--spitalstellenmarkt-category-2')"
            ></v-select>
            <v-select
                v-model="spitalstellenmarktCategoryID3"
                :items="cboValues"
                clearable
                item-text="text"
                item-value="id"
                :label="$t('oampublication/label--spitalstellenmarkt-category-3')"
            ></v-select>
        </v-card-text>
    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider } from 'vee-validate'

export default {
    components: {
        ValidationProvider,
    },
    data: () => ({
        connectorId: -19,
        loading: true,
        cboList: 'SpitalstellenmarktCategory',
    }),
    computed: {
        ...mapGetters('cbo', ['cboValues']),
        ...mapGetters('pub', ['getExtensionValueByKey']),
        spitalstellenmarktCategoryID1: {
            get: function () {
                return this.getExtensionValueByKey('SpitalstellenmarktCategoryID1')
            },
            set: function (val) {
                this.editExtension({ key: 'SpitalstellenmarktCategoryID1', value: val })
            },
        },
        spitalstellenmarktCategoryID2: {
            get: function () {
                return this.getExtensionValueByKey('SpitalstellenmarktCategoryID2')
            },
            set: function (val) {
                this.editExtension({ key: 'SpitalstellenmarktCategoryID2', value: val })
            },
        },
        spitalstellenmarktCategoryID3: {
            get: function () {
                return this.getExtensionValueByKey('SpitalstellenmarktCategoryID3')
            },
            set: function (val) {
                this.editExtension({ key: 'SpitalstellenmarktCategoryID3', value: val })
            },
        },
    },
    mounted() {
        this.getItems(this.cboList).then(() => {
            this.loading = false
            this.$emit('child-rendered')
        })
    },
    methods: {
        ...mapActions('cbo', ['getItems']),
        ...mapActions('pub', ['editExtension']),
    },
}
</script>

<style scoped></style>
